import React from 'react';
import { Link } from 'react-router-dom';

const posts = [
  {
    id: 1,
    title: 'AI in Legal Research: Revolutionizing Case Law Analysis',
    href: '#',
    description:
      'Explore how artificial intelligence is transforming legal research, enabling lawyers to analyze case law more efficiently and accurately than ever before.',
    imageUrl:
      'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80',
    date: 'Apr 12, 2023',
    datetime: '2023-04-12',
    category: { title: 'AI & Law', href: '#' },
    author: {
      name: 'Emily Chen',
      role: 'Legal Tech Analyst',
      href: '#',
      imageUrl:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  {
    id: 2,
    title: 'The Future of Smart Contracts in Legal Practice',
    href: '#',
    description:
      'Discover how blockchain-based smart contracts are reshaping legal agreements and what this means for the future of contract law and execution.',
    imageUrl:
      'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80',
    date: 'Mar 28, 2023',
    datetime: '2023-03-28',
    category: { title: 'Blockchain & Law', href: '#' },
    author: {
      name: 'Alex Johnson',
      role: 'Blockchain Legal Expert',
      href: '#',
      imageUrl:
        'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  },
  // Add more posts as needed
];

const Blog: React.FC = () => {
  return (
    <div className="bg-gray-900 min-h-screen">
      {/* Navigation */}
      <header className="bg-gray-900">
        <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Project Cicero</span>
              <img
                alt="Project Cicero Logo"
                src="/logo.png"
                className="h-8 w-auto"
              />
            </Link>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            <Link to="/#features" className="text-sm font-semibold leading-6 text-white">Features</Link>
            <Link to="/#pricing" className="text-sm font-semibold leading-6 text-white">Pricing</Link>
            <Link to="/blog" className="text-sm font-semibold leading-6 text-white">Blog</Link>
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <Link to="/login" className="text-sm font-semibold leading-6 text-white">
              Log in <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </nav>
      </header>

      {/* Blog Content */}
      <div className="py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-4xl">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">From the Project Cicero Blog</h2>
            <p className="mt-2 text-lg leading-8 text-gray-300">
              Stay updated with the latest in legal technology and AI advancements.
            </p>
            <div className="mt-16 space-y-20 lg:mt-20 lg:space-y-20">
              {posts.map((post) => (
                <article key={post.id} className="relative isolate flex flex-col gap-8 lg:flex-row">
                  <div className="relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-square lg:w-64 lg:shrink-0">
                    <img
                      alt=""
                      src={post.imageUrl}
                      className="absolute inset-0 h-full w-full rounded-2xl bg-gray-800 object-cover"
                    />
                    <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                  </div>
                  <div>
                    <div className="flex items-center gap-x-4 text-xs">
                      <time dateTime={post.datetime} className="text-gray-400">
                        {post.date}
                      </time>
                      <a
                        href={post.category.href}
                        className="relative z-10 rounded-full bg-gray-700 px-3 py-1.5 font-medium text-gray-300 hover:bg-gray-600"
                      >
                        {post.category.title}
                      </a>
                    </div>
                    <div className="group relative max-w-xl">
                      <h3 className="mt-3 text-lg font-semibold leading-6 text-white group-hover:text-gray-300">
                        <a href={post.href}>
                          <span className="absolute inset-0" />
                          {post.title}
                        </a>
                      </h3>
                      <p className="mt-5 text-sm leading-6 text-gray-400">{post.description}</p>
                    </div>
                    <div className="mt-6 flex border-t border-gray-700 pt-6">
                      <div className="relative flex items-center gap-x-4">
                        <img alt="" src={post.author.imageUrl} className="h-10 w-10 rounded-full bg-gray-800" />
                        <div className="text-sm leading-6">
                          <p className="font-semibold text-white">
                            <a href={post.author.href}>
                              <span className="absolute inset-0" />
                              {post.author.name}
                            </a>
                          </p>
                          <p className="text-gray-400">{post.author.role}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
